import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import { LinkProps } from "@insite/mobius/Link";
import closePopoverDrawer from "@NA/Handlers/ADIClosePopoverHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    links = "links",
}

export interface LinksIdArray {
    image: string;
    Url: string;
    title: string;
    GATag: string;
}

export interface LinksIdModel {
    fields: LinksIdArray;
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinksIdModel[];
    };
}

export interface ADIHeaderBrandsStyles {
    imageItem?: GridItemProps;
    link?: LinkProps;
    image?: LazyImageProps;
    gridContainer?: GridContainerProps;
}

export const adiHeaderBrandsStyles: ADIHeaderBrandsStyles = {
    imageItem: {
        css: css`
            padding: 5px;
            justify-content: center;
        `,
    },
    image: {
        css: css`
            mix-blend-mode: multiply;
            height: 100% !important;
            > img {
                width: 75px !important;
            }
        `,
    },
};
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        popover: state.ADIGlobalData.ClosePopOverStore.closeMenuPopover,
    };
};
const mapDispatchToProps = {
    closePopoverDrawer,
};

const styles = adiHeaderBrandsStyles;

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const ADIHeaderBrands: React.FC<Props> = ({ fields, popover, closePopoverDrawer }) => {
    const closePopover = (src: string) => {
        closePopoverDrawer({
            closeMenuPopover: popover + 1,
        });
    };
    return (
        <GridContainer {...styles.gridContainer}>
            {fields.links.map((item: any, i) => (
                <GridItem key={i + item.fields.Url} {...styles.imageItem}>
                    <Clickable
                        href={item.fields.Url}
                        {...styles.link}
                        onClick={() => {
                            closePopover(item.fields.Url);
                        }}
                    >
                        <LazyImage
                            {...styles.image}
                            src={item.fields.image}
                            altText={`${item.fields.title}`}
                            data-ga-promo={`${item.fields.GATag}`}
                        />
                    </Clickable>
                </GridItem>
            ))}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIHeaderBrands),
    definition: {
        group: "Basic",
        displayName: "ADI Header Brands",
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => item.fields.title,
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "title",
                        displayName: "Brand Name",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "image",
                        displayName: "Logo Image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "Url",
                        displayName: "Url",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "GATag",
                        displayName: "GA Tag",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
